/** @flow */
// Non authenticated paths
export const LOGIN_PATH = "/";
export const REGISTRATION_PATH = "/registration";
export const PASSWORD_SET_PATH = "/password/set";
export const NOT_FOUND_PATH = "/not-found";
export const NHS_UK_LINK = "https://www.nhs.uk/conditions/";
export const WORKING_FIT_LINK = "http://www.workingfit.co.uk/medical-evidence";
export const SAMARITANS_LINK = "https://www.samaritans.org/";
export const MEDICINES_LINK = "https://www.medicines.org.uk/emc/";
export const SERVICE_UNAVAILABLE_PATH = "/service-unavailable";
export const NO_ACCESS_PATH = "/no-access";
export const GSC_APP_PATH = "https://goodshapecentral.com/";

export const GENESIS_CLOUD_ONLINE_HREF = "https://apps.mypurecloud.ie";
export const CONFLUENCE_HREF = "https://confluence.alltimetech.co.uk/index.action#all-updates";
export const TRAINING_ACADEMY_HREF = "https://fast.wistia.com/embed/channel/u6oqbaq1q9";

// Authenticated paths
export const HOME_PATH = "/recording";

// Recording
export const RECORDING_PATH = "/recording";
export const RECORDING_OUTBOUND_CALLS_PATH = "/recording/outbound";

export const RECORDING_CALLBACK_PATH =
  "/recording/client/:clientId/employee/:employeeId/callback/:callbackId";
export const RECORDING_PATH_INBOUND_CALLS = "/recording/inbound";

export const REPORTING_TOOLS_TASKS_PATH = "/reporting/:clientId/tools/tasks";
// Management
export const MANAGEMENT_PATH = "/management";
export const MANAGEMENT_CONTACT_CENTRE_DASHBOARD_PATH = "/management/contact-centre/dashboard";
export const MANAGEMENT_CONTACT_CENTRE_QUEUE_MANAGEMENT_PATH =
  "/management/contact-centre/queue-management";
export const MANAGEMENT_CONTACT_CENTRE_SCRIPT_MANAGEMENT_PATH =
  "/management/contact-centre/script-management";
export const MANAGEMENT_SYSTEM_MESSAGES_PATH = "/management/system/messages";
export const MANAGEMENT_CLINICAL_GOVERNANCE_INCIDENT_REGISTER_PATH =
  "/management/clinical-governance/incident-register";
export const MANAGEMENT_CLINICAL_GOVERNANCE_INCIDENT_RATES_REPORT_PATH =
  "/management/clinical-governance/incident-rates-report";
export const MANAGEMENT_CLASSIFICATIONS_PATH = "/management/classifications";
export const MANAGEMENT_INTERVENTIONS_PATH = "/management/interventions";
export const MANAGEMENT_CONTACT_CENTRE_SERVICE_DESK_MANAGEMENT_PATH =
  "/management/contact-centre/service-desk-management";
export const HEALTH_NOTICES_MANAGEMENT_PATH = "/management/health-notices";
export const MANAGEMENT_IMAGE_LIBRARY_PATH = "/management/image-library";

// ----------------------------------------------------
// ----------------------------------------------------
// ----------------------------------------------------
// ----------------------------------------------------
// ----------------------------------------------------
// ----------------------------------------------------
// ----------------------------------------------------
// ----------------------------------------------------
// ----------------------------------------------------
// ----------------------------------------------------
// ----------------------------------------------------

export const CONTACT_CENTRE_ADVISOR_PROFILE_PATH = "/management/contact-centre/advisor-profile";
export const CONTACT_CENTRE_ADVISOR_PROFILE_DETAILS_PATH =
  "/management/contact-centre/advisor-profile/:advisorId";

// Client
export const ADMINISTRATION_PATH = "/administration";
export const ADMINISTRATION_CLIENT_PATH = "/administration/client";
export const ADMINISTRATION_CLIENT_DETAILS_PATH = "/administration/client/:clientId/client-details";
export const ADMINISTRATION_SLA_PERFORMANCE_PATH =
  "/administration/client/:clientId/sla-performance";

// Data
export const ADMINISTRATION_DATA_ADMIN_PATH = "/administration/data/:clientId/data-admin";
export const ADMINISTRATION_DATA_EXPORT_PATH = "/administration/data/:clientId/data-export";
export const ADMINISTRATION_DATA_QUALITY_PATH = "/administration/data/:clientId/data-quality";
export const ADMINISTRATION_DATA_LOAD_PATH = "/administration/data/:clientId/data-admin";
export const ADMINISTRATION_DATA_ADMIN_ARCHIVE_PATH =
  "/administration/data/:clientId/data-admin/archive"; // looks like not used

// Hierarchy
export const ADMINISTRATION_DATA_DATA_ADMIN_PATH = "/administration/data/:clientId/data-admin";
export const ADMINISTRATION_HIERARCHY_ADMIN_PATH =
  "/administration/hierarchy/:clientId/hierarchy-admin";
export const ADMINISTRATION_HIERARCHY_CHANGES_PATH =
  "/administration/hierarchy/:clientId/hierarchy-changes";
export const ADMINISTRATION_HIERARCHY_NOTIFICATIONS_PATH =
  "/administration/hierarchy/:clientId/hierarchy-notifications";
export const ADMINISTRATION_HIERARCHY_CHANGE_LOG_PATH =
  "/administration/hierarchy/:clientId/change-history";

// Service
export const ADMINISTRATION_SERVICE = "/administration/service/:clientId";
export const ADMINISTRATION_SERVICE_SETTINGS = "/administration/service/:clientId/general/settings";
export const ADMINISTRATION_SERVICE_ABSENCE_REASONS =
  "/administration/service/:clientId/general/absence-reasons";
export const ADMINISTRATION_SERVICE_ABSENCE_REASON_DETAILS =
  "/administration/service/:clientId/general/absence-reasons/:absenceReasonId/:status";
export const ADMINISTRATION_SERVICE_NURSE_DECLINED_REASONS =
  "/administration/service/:clientId/general/nurse-declined-reasons";
export const ADMINISTRATION_SERVICE_NURSE_DECLINED_REASON_DETAILS =
  "/administration/service/:clientId/general/nurse-declined-reasons/:reasonId/:status";
export const ADMINISTRATION_SERVICE_REPORTING_PARAMETERS =
  "/administration/service/:clientId/general/reporting-parameters";
export const ADMINISTRATION_SERVICE_SYSTEM_ACCESS =
  "/administration/service/:clientId/security/system-access";
export const ADMINISTRATION_SERVICE_EMAIL_CONTROLS =
  "/administration/service/:clientId/security/email-controls";
export const ADMINISTRATION_SERVICE_EMPLOYEE_IDENTIFICATION =
  "/administration/service/:clientId/security/employee-identification";
export const ADMINISTRATION_SERVICE_DEFAULT_STANDARD_SCRIPTS =
  "/administration/service/:clientId/call-flow/default-standard-scripts";
export const ADMINISTRATION_SERVICE_DEFAULT_STANDARD_SCRIPT_DETAILS =
  "/administration/service/:clientId/call-flow/default-standard-scripts/:scriptId/:status";
export const ADMINISTRATION_SERVICE_STANDARD_QUESTION_DETAILS =
  "/administration/service/:clientId/call-flow/dynamic-questions/standard/:standardQuestionId/:status";
export const ADMINISTRATION_SERVICE_DYNAMIC_QUESTIONS =
  "/administration/service/:clientId/call-flow/dynamic-questions";
export const ADMINISTRATION_SERVICE_DYNAMIC_QUESTION_DETAILS =
  "/administration/service/:clientId/call-flow/dynamic-questions/:dynamicQuestionId/:status";
export const ADMINISTRATION_SERVICE_DEPARTMENT_SPECIFIC_SCRIPT_DETAILS =
  "/administration/service/:clientId/call-flow/default-standard-scripts/department/:scriptId/:status";
export const ADMINISTRATION_SERVICE_EAP_SIGNPOSTING =
  "/administration/service/:clientId/call-flow/signposting";
export const ADMINISTRATION_SERVICE_EAP_SIGNPOSTING_DETAILS =
  "/administration/service/:clientId/call-flow/eap-signposting/:eapSignpostingId/:status";
export const ADMINISTRATION_SERVICE_EMAIL_NOTIFICATIONS =
  "/administration/service/:clientId/notifications/email";
export const ADMINISTRATION_SERVICE_EMAIL_NOTIFICATION_DETAILS =
  "/administration/service/:clientId/notifications/email/:ruleId";
export const ADMINISTRATION_SERVICE_MANAGER_SMS =
  "/administration/service/:clientId/notifications/manager-sms";
export const ADMINISTRATION_SERVICE_EMPLOYEE_SMS =
  "/administration/service/:clientId/notifications/employee-sms";
export const ADMINISTRATION_SERVICE_ALERTS =
  "/administration/service/:clientId/notifications/alerts";
export const ADMINISTRATION_SERVICE_ALERT_DETAILS =
  "/administration/service/:clientId/notifications/alerts/:alertId/:status";
export const ADMINISTRATION_SERVICE_SPECIAL_CONTACTS =
  "/administration/service/:clientId/notifications/special-contacts";
export const ADMINISTRATION_SERVICE_PROCESSES = "/administration/service/:clientId/processes";
export const ADMINISTRATION_SERVICE_RETURN_TO_WORK_DETAILS =
  "/administration/service/:clientId/processes/return-to-work/:processId/:status";

export const ADMINISTRATION_SERVICE_ABSENCE_MONITORING_DETAILS =
  "/administration/service/:clientId/processes/absence-monitoring/:processId/:status";
export const ADMINISTRATION_SERVICE_REFERRAL_DETAILS =
  "/administration/service/:clientId/processes/referrals/:processId/:status";
export const ADMINISTRATION_SERVICE_REASON_SPECIFIC_SCRIPT_DETAILS =
  "/administration/service/:clientId/call-flow/default-standard-scripts/reason/:scriptId/:status";
export const ADMINISTRATION_SERVICE_USER_ACCOUNTS =
  "/administration/service/:clientId/security/user-accounts";

// Employee
export const ADMINISTRATION_EMPLOYEE_SEARCH = "/administration/admin/:clientId/employee/client";
export const ADMINISTRATION_EMPLOYEE_PERSONAL_DETAILS =
  "/administration/:clientId/employee/:employeeId/personal-details";
export const ADMINISTRATION_EMPLOYEE_ABSENCES =
  "/administration/:clientId/employee/:employeeId/absences";
export const ADMINISTRATION_EMPLOYEE_ABSENCE_DETAILS =
  "/administration/:clientId/employee/:employeeId/absences/:absenceId";
export const ADMINISTRATION_EMPLOYEE_MY_DETAILS = "/administration/employee/my-details";
export const ADMINISTRATION_EMPLOYEE_MY_ABSENCE = "/administration/employee/my-absences/:absenceId";

// training
export const TRAINING_PATH = "/training";
export const TRAINING_FAQ_PATH = "/training/faq";
export const TRAINING_GLOSSARY_PATH = "/training/glossary";

// Reporting
export const REPORTING_PATH = "/reporting";
export const REPORTING_DATA_FORECASTS_PATH = "/reporting/:clientId/data-forecasts";
export const REPORTING_DASHBOARD_PATH = "/reporting/:clientId/tools/dashboard";
export const REPORTING_ACTIVITYFEED = "/reporting/:clientId/tools/activityfeed";
export const REPORTING_CORONAVIRUS = "/reporting/:clientId/tools/coronavirus";
export const REPORTING_INDEX = "/reporting/:clientId/tools/index";

export const REPORTING_TASKS_FULL_PATH = "/reporting/:clientId/tools/tasks/:taskId?/:taskType?";
export const REPORTING_TASKS_PATH = "/reporting/:clientId/tools/tasks";
export const REPORTING_MY_NOTIFICATIONS_PATH = "/reporting/:clientId/tools/notifications";
export const REPORTING_REPORTS_OVERVIEW_PATH = "/reporting/:clientId/reports/overview";
export const REPORTING_REPORTS_ABSENCE_DETAILS_PATH =
  "/reporting/:clientId/reports/absence-details";
export const REPORTING_REPORTS_ABSENCE_DETAILS_REPORT_PATH =
  "/reporting/:clientId/reports/absence-details/report";
export const REPORTING_TOOLS_NOTIFICATION = "/reporting/:clientId/tools/notifications";
export const REPORTING_TOOLS_PROFILE = "/reporting/:clientId/tools/profile";
export const REPORTING_REPORTS_EMPLOYEE_DETAILS = "/reporting/:clientId/reports/employee-details";
export const REPORTING_ABSENCE_MONITORING_DETAILS_OVERVIEW =
  "/reporting/:clientId/reports/absence-monitoring";
export const REPORTING_ABSENCE_MONITORING_DETAILS_REPORT =
  "/reporting/:clientId/reports/absence-monitoring/report";
export const REPORTING_RTW_DETAILS_OVERVIEW = "/reporting/:clientId/reports/rtw-details";
export const REPORTING_RTW_DETAILS_REPORT = "/reporting/:clientId/reports/rtw-details/report";
export const REPORTING_ALERT_DETAILS_OVERVIEW = "/reporting/:clientId/reports/alert-details";
export const REPORTING_ALERT_DETAILS_REPORT = "/reporting/:clientId/reports/alert-details/report";
export const REPORTING_REFERRAL_DETAILS_REPORT = "/reporting/:clientId/reports/referral/report";
export const REPORTING_REPORTS_REFERRAL_DETAILS = "/reporting/:clientId/reports/referral-details";
export const REPORTING_REPORTS_ALERT_DETAILS = "/reporting/:clientId/reports/alert-details";
export const REPORTING_FOCUS_LISTS_EMPLOYEE = "/reporting/:clientId/focus-lists/employee";
export const REPORTING_FOCUS_LISTS_EMPLOYEE_REPORT =
  "/reporting/:clientId/focus-lists/employee/report";
export const REPORTING_FOCUS_LISTS_DEPARTMENT = "/reporting/:clientId/focus-lists/department";
export const REPORTING_FOCUS_LISTS_DEPARTMENT_REPORT =
  "/reporting/:clientId/focus-lists/department/report";
export const REPORTING_FOCUS_LISTS_MANAGER = "/reporting/:clientId/focus-lists/manager";
export const REPORTING_FOCUS_LISTS_MANAGER_REPORT =
  "/reporting/:clientId/focus-lists/manager/report";
export const REPORTING_TRENDS = "/reporting/:clientId/trends";
export const REPORTING_TRENDS_OVERVIEW = "/reporting/:clientId/trends/overview";
export const REPORTING_TRENDS_ABSENCE_RATE = "/reporting/:clientId/trends/absence-rate";
export const REPORTING_TRENDS_ABSENCE_RATE_REPORT =
  "/reporting/:clientId/trends/absence-rate/report";
export const REPORTING_TRENDS_ABSENCE_REASON = "/reporting/:clientId/trends/absence-reason";
export const REPORTING_TRENDS_ABSENCE_REASON_REPORT =
  "/reporting/:clientId/trends/absence-reason/report";
export const REPORTING_TRENDS_COMPLIANCE = "/reporting/:clientId/trends/compliance";
export const REPORTING_TRENDS_COMPLIANCE_REPORT = "/reporting/:clientId/trends/compliance/report";
export const REPORTING_TRENDS_SPOTLIGHT = "/reporting/:clientId/trends/spotlight";
export const REPORTING_TRENDS_SPOTLIGHT_REPORT = "/reporting/:clientId/trends/spotlight/report";
export const REPORTING_TRENDS_SLA_PERFORMANCE = "/reporting/:clientId/trends/sla-performance";
export const REPORTING_TRENDS_PLANNED_LEAVE = "/reporting/:clientId/trends/planned-leave";

// Reporting -> Employees
export const REPORTING_EMPLOYEES = "/reporting/:clientId/employees";
export const REPORTING_EMPLOYEES_EMPLOYEE_DETAILS =
  "/reporting/:clientId/employees/:employeeId/employee-details";
export const REPORTING_EMPLOYEE_EMPLOYMENT_DETAILS =
  "/reporting/:clientId/employees/:employeeId/employment-details";
export const REPORTING_EMPLOYEES_ABSENCE_STATISTICS =
  "/reporting/:clientId/employees/:employeeId/absence-statistics";
export const REPORTING_EMPLOYEES_ABSENCE_NOTES =
  "/reporting/:clientId/employees/:employeeId/absence-notes";
export const REPORTING_EMPLOYEES_DOCUMENTS = "/reporting/:clientId/employees/:employeeId/documents";
export const ADMINISTRATION_EMPLOYEES_DOCUMENTS =
  "/reporting/:clientId/employees/:employeeId/documents";
export const REPORTING_EMPLOYEES_USER_ACCOUNT_DETAILS =
  "/reporting/:clientId/employees/:employeeId/user-account-details";
export const REPORTING_EMPLOYEES_ABSENCE_MONITORING =
  "/reporting/:clientId/employees/:employeeId/absence-monitoring";
export const REPORTING_EMPLOYEE_ABSENCE_HISTORY =
  "/reporting/:clientId/employees/:employeeId/absence-history";
export const REPORTING_EMPLOYEE_ABSENCES = "/reporting/:clientId/employees/:employeeId/absences";
export const REPORTING_EMPLOYEE_ABSENCE_DETAILS =
  "/reporting/:clientId/employees/:employeeId/absences/:absenceId";
export const REPORTING_EMPLOYEE_OUTSTANDING_TASKS =
  "/reporting/:clientId/employees/:employeeId/employee-outstanding-tasks";
export const REPORTING_EMPLOYEE_ABSENCE_HISTORY_DETAILS =
  "/reporting/:clientId/employees/:employeeId/absence-history/:absenceId";
export const REPORTING_EMPLOYEE_NOTIFICATION_DETAILS =
  "/reporting/:clientId/employees/:employeeId/notification-details";
export const REPORTING_EMPLOYEE_MEDICAL_DETAILS =
  "/reporting/:clientId/employees/:employeeId/medical-details";
export const REPORTING_EMPLOYEE_NOTIFICATIONS_SENT_TO =
  "/reporting/:clientId/employees/:employeeId/notifications-sent-to";
export const REPORTING_EMPLOYEE_NOTIFICATIONS_RECEIVED_FOR =
  "/reporting/:clientId/employees/:employeeId/notifications-received-for";
export const REPORTING_EMPLOYEE_PERSONAL_DETAILS =
  "/reporting/:clientId/employees/:employeeId/personal-details";
// Reporting -> Manager
export const REPORTING_MANAGER = "/reporting/:clientId/managers";
export const REPORTING_MANAGER_DETAILS =
  "/reporting/:clientId/managers/:employeeId/manager-details";
export const REPORTING_MANAGER_COMPLIANCE = "/reporting/:clientId/managers/:employeeId/compliance";
export const REPORTING_MANAGER_NOTIFICATIONS =
  "/reporting/:clientId/managers/:employeeId/notifications";
export const REPORTING_EMPLOYEES_DOWNLOAD_REPORT =
  "/reporting/:clientId/employees/:employeeId/download-report";
export const REPORTING_EMPLOYEES_RISK_PROFILE =
  "/reporting/:clientId/employees/:employeeId/current-forecasts";
export const REPORTING_EMPLOYEE_WELLBEING_REFERRALS =
  "/reporting/:clientId/employees/:employeeId/wellbeing-referrals";
export const REPORTING_REFERRALS_REPORTS = "/reporting/:clientId/referrals";
export const REPORTING_MI_PRESENTATIONS = "/reporting/:clientId/mi-presentations";

// Profile
export const PROFILE_PATH = "/user/profile";
export const PROFILE_MY_DETAILS = "/user/profile/my-details";
export const PROFILE_MY_ABSENCE = "/user/profile/my-absences/:absenceId";
export const PROFILE_MY_ABSENCE_STAGE = "/user/profile/my-absence-stage";
export const PROFILE_MY_EMPLOYEES = "/user/profile/my-employees";
export const PROFILE_MY_EMPLOYEE_DETAILS = "/user/profile/my-employees/:employeeId";

// Help
export const HELP_PATH = "/help";
export const HELP_QUESTION_PATH = "/help/:questionId";

// Mobile App
export const MOBILE_APP_PATH = "/mobile-app";
